import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')

    fb.usersCollection.doc(user.uid).onSnapshot(doc => {
      store.commit('setUserProfile', doc.data())
    })

  }
})

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    spinner: false,
    diningOptions: false,
    dashboard: {
      panel: 'trailHub',
      selectedCustomTab: false,
      data: {
        design: {},
        modules: {}
      }
    },
    admin: {
      panel: 'dashboard'
    },
    modules: [
      {
        machine_name: 'dining',
        config: {
          title: "Dining",
          active: false,
          locations: []
        }
      },
      {
        machine_name: 'trailHub',
        config: {
          title: "Trail Hub",
          active: false
        }
      },
      {
        machine_name: 'weather',
        config: {
          title: "Weather",
          active: false
        }
      },
      {
        machine_name: 'googleCalendar',
        config: {
          title: "Google Calendar",
          active: false
        }
      },
      {
        machine_name: 'webcams',
        config: {
          title: "Webcams",
          active: false
        }
      },
      {
        machine_name: 'customTabs',
        config: {
          title: "Custom Tabs",
          active: false
        }
      }
    ]
  },
  actions: {
    clearData({ commit }) {
      commit('setCurrentUser', null)
      commit('setUserProfile', {})
    },
    fetchUserProfile({ commit, state }) {
      fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
        let userData = res.data()
        userData.id = state.currentUser.uid
        commit('setUserProfile', userData)
      }).catch(err => {
        console.log(err)
      })
    },
    updateProfile({ commit, state }, data) {
      let name = data.name
      fb.usersCollection.doc(state.currentUser.uid).update({ name })
    }
  },
  mutations: {
    setStateProperty (state, options) {
      state[options.property] = options.value
    },
    spinner (state, val) {
      if (val) {
        state.spinner = true
      } else {
        state.spinner = false
      }
    },
    fetchDashboard(state, val) {
      fb.dashboardsCollection.doc(val.id).get().then(doc => {
        state.dashboard.data = doc.data()
        state.dashboard.data.id = doc.id
        if (val.customStyles === true) {
          // CUSTOM CSS INJECTED
          function addStyleString(str) {
            var node = document.createElement('style');
            node.innerHTML = str;
            document.body.appendChild(node);
          }
          addStyleString(state.dashboard.data.design.css);
        }

      }).catch(err => {
        console.log(err)
      })
    },
    setCurrentUser(state, val) {
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    changePanel(state, val) {
      state.dashboard.panel = false
      if (val !== 'customTabs') {
        router.push({ name: 'Dashboard Pane', params: { pane: val } })
      }
      setTimeout(function () {
        state.dashboard.panel = val
      }, 10)
    },
    setSelectedCustomTab(state, val) {
      state.dashboard.selectedCustomTab = val
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js